{
	"widgetActions": {
		"settingsColumns": "Настройка колонок"
	},
	"orders": {
		"typesAssets": {
			"stocks": "Акции",
			"options": "Опционы",
			"postTrading": "Пост-трейдинг"
		},
		"activeOrders": {
			"filled": "Исполненные",
			"open": "Открытые",
			"canceled": "Отмененные",
			"OPEXP": "Истёк",
			"OPEXC": "Исполнен",
			"OPASN": "Рассчитан"
		}
	}
}
